import $ from 'jquery';

/**
 * A component which asks the user to confirm a deletion action.
 */
const ConfirmDeleteModal = {
    /**
     * Bind a modal to the selector.
     *
     * @param {string} selector Selector to bind
     */
    bind(selector) {
        $(selector).on('click', (e) => {
            e.preventDefault();

            const $target = $(e.target);
            const $modal = $('.js-confirm-delete-modal');
            const action = $target.attr('href') || $target.attr('data-action');

            $modal.find('form').attr('action', action);

            $modal.on('hidden.bs.modal', () => {
                $modal.resetLoadingButtons();
                $modal.off('hidden.bs.modal');
            });

            $modal.modal('show');
        });
    },
};

export default ConfirmDeleteModal;
